<!-- Data manager / explorer - note also refer to explorer-list.component.html -->

<!--
<div id="data-wrapper">
  <ul>
  <li>Import from DropBox</li>
  <li>Upload from computer</li>
  <li (click)="selectTab('files')">Select from files</li>
  <li (click)="selectTab('library')">Choose from library</li>
</ul>

<div *ngIf="selectedTab == 'library'" class="library-container">
  <li>Library links</li>
</div>-->

<div *ngIf="selectedTab == 'files'" class="explorer-container fdm-drag-drop-zone-neutral"
      (drop)="mainService.dropFile($event)" (dragover)="dragOver($event)" [ngClass]="{'fdm-drag-drop-zone-hover':mainService.isOver}"
      (dragenter)="mainService.isOver = true;helloDrop($event,true)" (dragleave)="helloDrop($event,false)">
  
    
    <!-- Create new folder -->

    <mat-toolbar ngClass="{'primary-bg':fileList?.selectedFiles?.length}">
      <!--<span *ngIf="files && files.col === 'folder' && files.val === -1">
        {{'FILE_LIST.NAV.SELECT_FOLDER' | translate }}
      </span>-->

      <span id="container" class="dir_pad">
        <button class="ml-1" id="add-folder" color="primary" [matTooltip]="'FILE_LIST.NAV.NEW_FOLDER_ONLY' | translate " mat-raised-button *ngIf="selectedFolder" (click)="newFolder(selectedFolder)">
                <fa-icon [icon]="['fas', 'folder-plus']" style="font-size: 24px;"></fa-icon>
              </button>
  
          <!--<button class="ml-1" [matTooltip]="'FILE_LIST.NAV.GOOGLE_DRIVE' | translate " mat-raised-button color="primary" (click)="openGoogleDrive()"><fa-icon style="font-size: 24px;"  [icon]="['fab', 'google-drive']">  </fa-icon>
        </button>
  
          <button class="ml-1" #dropboxButton id="dropboxButton" [matTooltip]="'FILE_LIST.NAV.DROPBOX' | translate " mat-raised-button color="primary" (click)="openDropBox()"><fa-icon style="font-size: 24px;" [icon]="['fab', 'dropbox']">  </fa-icon>
        </button>-->
  
        <!-- Drag or upload from computer -->
        <button class="ml-1" id="file-upload" mat-raised-button  [matTooltip]="'FILE_LIST.NAV.UPLOAD' | translate"  color="primary"  [disabled]="!(rootFolder && (rootFolder['root'] == 'myFiles' || rootFolder['root'] == 'google-drive' || rootFolder['root'] == 'dropbox'))" (click)="fileInput.click()">
          <fa-icon style="font-size: 24px;" icon="file-import"></fa-icon>
        </button>
        <input hidden type="file" (change)="mainService.uploadFiles($event);fileInput.value = null" multiple="multiple" #fileInput>
       
       <!-- Quick Guides icon-->
        <button mat-icon-button matTooltip="{{ 'NAV.QUICK_GUIDES' | translate }}" class="fdm-linked" (click)="uiManager.toggleQuickGuidePopup('explorer', true)">
					<fa-icon icon="question-circle"></fa-icon>
				</button>
        
        <!-- Moved to quick guide
      <button class="ml-1"  mat-raised-button  [matTooltip]="'FILE_LIST.NAV.SUPPORTED_FORMAT' | translate"  color="primary"   (click)="openSupportedFormatDialog()">
          <fa-icon class="mr-2" style="font-size: 24px;" icon="info"></fa-icon>
        <small>{{'FILE_LIST.NAV.SUPPORTED_FORMAT' | translate }}</small>
      </button> -->
  
      </span>
  
      <span class="spacer"></span>
  
      <ng-container *ngIf="!isDialog">
  
        <div style="text-align:right;border-left:solid 1px #eee;padding-left:30px;margin-left:30px;">

          <span *ngIf="fileList?.selectedFiles?.length == 1"> {{ fileList?.selectedFiles[0].name }} </span>
          <span *ngIf="fileList?.selectedFiles?.length > 1"> {{ fileList?.selectedFiles.length }} files</span>
  
          <!-- Download file-->
          <span *ngIf="fileList?.selectedFiles?.length"><a mat-icon-button [matTooltip]="'GENERIC.DOWNLOAD' | translate " vlink="data" [model]="fileList?.selectedFiles[0]"><fa-icon icon="download"></fa-icon></a></span>
          
           <!-- Delete file-->
          <span *ngIf="fileList?.selectedFiles?.length"><button [disabled]="!canAddFile" mat-icon-button color="warn"  [matTooltip]="'GENERIC.DELETE' | translate " (click)="forceDelete(fileList?.selectedFiles)"><fa-icon icon="trash"></fa-icon></button></span>
  
        </div>
  
      </ng-container>

      <!-- File search field -->
      <div style="text-align:right;border-left:solid 1px #eee;padding-left:30px;margin-left:30px;padding-top:20px;">
        <mat-form-field id="file-search" class="fdm-search" [matTooltip]="'FILE_LIST.SEARCH_FOLDERS' | translate">
          <span matPrefix style="padding:0 6px;"><fa-icon icon="search"></fa-icon></span>

          <input matInput [formControl]="searchCont"  placeholder=" {{ 'GENERIC.SEARCH' | translate }}" style="border-bottom:solid 1px #ccc;" [class.fdm-selected]="searchCont.value">
          <span matSuffix *ngIf="searchCont.value"><button mat-icon-button (click)="searchCont.setValue(null); searchFilesFolderWithoutGlobal(); isSearch = false"><fa-icon icon="times"></fa-icon></button></span>
        </mat-form-field>
      </div>
  
      <!--<span><button mat-icon-button *ngIf="!isSearch" [matTooltip]="'FILE_LIST.NAV.SEARCH_FOLDERS' | translate " (click)="isSearch = true"><fa-icon icon="search"></fa-icon></button></span>
      <span><button mat-icon-button *ngIf="isSearch" [matTooltip]="'FILE_LIST.NAV.SEARCH_FOLDERS' | translate " (click)="searchCont.setValue(null); searchFilesFolderWithoutGlobal(); isSearch = false"><fa-icon icon="times"></fa-icon></button></span> -->
  
      <mat-menu #actionsFolder="matMenu" [overlapTrigger]="false">

      <!-- File preview -->
      <button mat-menu-item (click)="viewItem(fileList?.selectedFiles)">
        <fa-icon [fixedWidth]="true" icon="eye"></fa-icon> {{'FILE_LIST.PREVIEW' | translate }}
    </button>

    <mat-divider></mat-divider>
      
      <!-- Rename file -->
      <button id='rename-file' mat-menu-item [disabled]="fileList?.selectedFiles?.length != 1 || fileList?.selectedFiles[0].canWrite" (click)="renameFile(fileList?.selectedFiles[0])"><fa-icon [fixedWidth]="true" icon="i-cursor"></fa-icon> {{'FILE_LIST.RENAME.FILE_TITLE' | translate }}</button>
 
      <!-- Move file -->
      <button id='move-file' mat-menu-item [disabled]="!canAddFile" (click)="moveFiles(fileList?.selectedFiles)">
        <fa-icon [fixedWidth]="true" icon="file-export"></fa-icon> {{'FILE_LIST.MOVE.FILE_TITLE' | translate }}
      </button>

      <!-- Download file -->
      <a mat-menu-item vlink="data" id='download-file' mat-menu-item vlink="data" [model]="fileList?.selectedFiles[0]">
            <fa-icon [fixedWidth]="true" icon="download"></fa-icon> {{'FILE_LIST.DOWNLOAD.FILE' | translate }}
      </a>

      <mat-divider></mat-divider>
      
      <!-- Apply transform to file -->
          <button mat-menu-item *ngIf="adHocs?.length" [disabled]="!canAddFile || fileList?.selectedFiles?.length != 1 || fileList?.selectedFiles[0].status == 'failed'"  [matMenuTriggerFor]="adHocsz">
              <fa-icon [fixedWidth]="true" icon="cogs"></fa-icon> {{'FILE_LIST.APPLY_TRANSFORM' | translate }}
          </button>
  
        <mat-menu #adHocsz="matMenu" [overlapTrigger]="false">
              <button mat-menu-item *ngFor="let cur of adHocs" (click)="startAdHoc(fileList?.selectedFiles[0],cur)"><fa-icon [fixedWidth]="true" [icon]="'ICON.' + cur?.uid | translate"></fa-icon> {{'TYPES.' + cur?.uid | translate }}</button>
        </mat-menu>
        <mat-menu #fileTanz="matMenu" [overlapTrigger]="false">
            <button mat-menu-item *ngFor="let cur of folderXforms" (click)="doXform(cur)"><fa-icon [fixedWidth]="true" [icon]="'ICON.' + cur?.uid | translate"></fa-icon> {{'TYPES.' + cur?.uid | translate }}</button>
        </mat-menu>

    <!-- Delete file -->
    <button mat-menu-item color="warn" [disabled]="!canAddFile" (click)="forceDelete(fileList?.selectedFiles)"><fa-icon [fixedWidth]="true" icon="trash"></fa-icon> {{'GENERIC.DELETE' | translate }}</button>

    <!--(click)="infoItem(fileList?.selectedFiles)    @haresh, where is the infoItem function? -->
        <!-- <button mat-menu-item>
            info <fa-icon [fixedWidth]="true" icon="info-circle"></fa-icon> {{'FILE_LIST.NAV.INFO' | translate }}
        </button>
      -->
    </mat-menu> 
  </mat-toolbar>
  
      <div style="overflow-y: scroll;" class="dir_view mat-paginator">
  
        <explorer-tree
            [moreMenu]="folderMenu"
            [baseQuery]="dataType == 'Dataset'?null:{transforms:true,transform_type:dataType}"
            #myPeachTree
            (folderSelected)="selectFolder($event)"
            (rootSelect)="selectRoot($event)"
            class="mr-1"></explorer-tree>
  
        <!--<button *ngIf="canAddFolder && selectedFolder" mat-fab class="bottom-right" color="accent" [matMenuTriggerFor]="folderAddMenu"><mat-icon>create_new_folder</mat-icon></button>
        <button *ngIf="canAddFolder && !selectedFolder" mat-fab class="bottom-right" color="accent" (click)="newFolder()"><mat-icon>create_new_folder</mat-icon></button>-->
  
        <mat-menu #folderMenu="matMenu" [overlapTrigger]="false">

            <!-- Rename folder-->
            <button mat-menu-item [disabled]="!selectedFolder?.canWrite" (click)="rename(selectedFolder)"><fa-icon icon="i-cursor" [fixedWidth]="true"></fa-icon> {{'FILE_LIST.RENAME.FOLDER_TITLE' | translate }}</button>
  
            <!-- Move folder -->
           <!-- <button mat-menu-item [disabled]="!selectedFolder?.canWrite" (click)="moveFolder(selectedFolder)"><fa-icon icon="file-export" [fixedWidth]="true"></fa-icon> {{'FILE_LIST.MENUS.MOVE_FOLDER' | translate }}</button>
  -->
            <!-- Download folder -->
            <button mat-menu-item (click)="folderDownload(selectedFolder)"><fa-icon icon="download" [fixedWidth]="true"></fa-icon> {{'FILE_LIST.DOWNLOAD.FOLDER' | translate }}</button>
  
            <mat-divider></mat-divider>

            <!-- Apply transform -->
            <button mat-menu-item *ngIf="adHocF?.length"  [matMenuTriggerFor]="adHocFolder">
            <fa-icon [fixedWidth]="true" icon="cogs"></fa-icon> {{'FILE_LIST.APPLY_TRANSFORM' | translate }}
            </button>
            
            <!-- Delete folder -->
            <button mat-menu-item color="warn" (click)="folderDelete(selectedFolder)"><fa-icon icon="trash" [fixedWidth]="true"></fa-icon> {{'GENERIC.DELETE' | translate }}</button>

            <mat-divider></mat-divider>

            <!-- Folder properties -->
            <button mat-menu-item [disabled]="!selectedFolder?.canWrite" (click)="editFolderProperties(selectedFolder)"><fa-icon icon="cog" [fixedWidth]="true"></fa-icon> {{'FILE_LIST.FOLDER_PROPERTIES' | translate }}</button>
  
        </mat-menu>
  
        <mat-menu #adHocFolder="matMenu" [overlapTrigger]="false">
              <button mat-menu-item *ngFor="let cur of adHocF" (click)="startAdHocFolder(selectedFolder,cur)"><fa-icon *ngIf="cur" [fixedWidth]="true" [icon]="'ICON.' + cur?.uid | translate"></fa-icon> {{'TYPES.' + cur?.uid | translate }}</button>
        </mat-menu>
  
      </div>
  
      <div style="overflow-y: scroll;" class="file_view mat-paginator" >
  
        <app-quick-guides *ngIf="permissions?.can?.show_intro_tour?.site_settings && (uiManager.toggleQuickGuide$ | async)?.screen == 'explorer' && (uiManager.toggleQuickGuide$ | async)?.show" [context]="this" guidesMode="explorer"></app-quick-guides>

        <explorer-list
            #fileList
            [searchQ] = "searchCont.value"
            [moreMenu]="actionsFolder"
            [disableSelect]="isDialog && !selectFiles"
            [query]="files"
            (startAdHoc)="startAdHoc2($event)"
            (doubleClicked)="viewItem([$event])"
            (onDelete)="forceDelete($event)"
            (selectionChanged)="setSelection($event)"
            (photoTypeCount)="processorCheck($event)"></explorer-list>
  
        <!--(click)="plotItemOnCesium(fileList?.dataSource?.results?.items)"[matMenuTriggerFor]="fileTanz"-->
          <!--<div class="bottom-right" *ngIf="canAddFile && selectedFolder" >
              <button class="mr-1"  [matTooltip]="'FILE_LIST.DIALOG.STEP3' | translate" mat-fab *ngIf="showProcessor" color="primary"
                      (click)="plotItemOnCesium(fileList?.dataSource?.results?.items)">
                  <fa-layers class="fa-fw">
                    <fa-icon [icon]="['fal', 'cloud']" size="lg" transform="grow-1 left-2"></fa-icon>
                    <fa-icon [inverse]="true" [icon]="['fas','bolt']" transform="shrink-2"></fa-icon>
                  </fa-layers>
              </button>
              &lt;!&ndash;<button mat-fab  color="accent" (click)="fileInput.click()" [matTooltip]="'FILE_LIST.NAV.UPLOAD' | translate"><mat-icon>note_add</mat-icon></button>
            <input hidden type="file" (change)="uploadFiles($event)" #fileInput>&ndash;&gt;
          </div>-->
      </div>
  
  </div>

<!-- </div> -->